import React from "react";
import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

const CustomField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#5E70CC",
    fontSize: "14px",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      // borderColor: "#00000014",
      borderColor: "#dad8d8",
      borderRadius: "10px",
      // borderColor: "white",
    },

    "&:hover fieldset": {
      borderColor: "#5E70CC",
      borderRadius: "10px",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#616FC6",
      borderRadius: "10px",
    },
  },
});
const Input = ({
  type,
  value,
  label,
  disabled,
  name,
  shrink,
  mb,
  accept = "",
  ...props
}) => {
  return (
    <CustomField
      className="input_Th"
      id={name}
      label={label}
      type={type}
      disabled={disabled}
      name={name}
      sx={{
        mb: mb === undefined ? 4 : mb,
        color: "#000000",
        borderRadius: "15px",
        width: "100%",
        // marginLeft: 2,
      }}
      inputProps={{
        style: { fontSize: type === "file" ? 16 : 14 },
        accept: accept,
      }}
      inputLabelProps={{
        style: { fontSize: type === "file" ? 16 : 14 },
        shrink: shrink,
      }}
      // fullWidth
      value={value}
      size={props?.size || "small"}
      autoComplete={props.autoComplete ?? "off"}
      {...props}
    />
  );
};

export default Input;
